import { CONTA_LOCAL } from '@sheafyield/sync';

/**
 * O tanto de cliente que ler o dono exige: só a sessão. Declarado aqui, e
 * não importado de `app/sessao.ts`, para o teste passar um dublê de duas
 * linhas — e para este módulo não depender do canal ao vivo.
 */
export interface SessaoDeAutenticacao {
  auth: {
    getSession(): Promise<{
      data: { session: { user: { id: string } } | null };
    }>;
  };
}

/**
 * O `user_id` que o app carimba numa linha nova quando **não há conta
 * nenhuma** — reexportado de `@sheafyield/sync`, onde ele passou a morar
 * porque a purga de troca de conta precisa reconhecê-lo para **adotar** (e
 * não apagar) o que foi escrito sem conta. A definição e a razão inteira
 * estão em `packages/sync/src/protocolo.ts`.
 */
export { CONTA_LOCAL };

/** De quem é a linha que está sendo escrita agora. */
export type DonoDasLinhas = () => Promise<string>;

/**
 * O dono vem da **sessão de autenticação**, e não do banco local.
 *
 * A versão anterior lia `estado['usuario']`, que o motor só grava dentro de
 * um ciclo bem-sucedido. No modo manual `aoMudarSessao` volta antes de
 * sincronizar; entre o login e o primeiro ciclo não há ciclo nenhum; e
 * quem entra na conta sem rede também não tem ciclo. Nos três casos havia
 * uma pessoa logada escrevendo linhas da `CONTA_LOCAL`.
 *
 * `auth.getSession()` lê o armazenamento local do supabase-js: não vai à
 * rede, funciona offline, e é a mesma fonte que `src/app/sessao.ts` já usa
 * para armar o canal ao vivo.
 */
export function donoDaSessao(cliente: SessaoDeAutenticacao): DonoDasLinhas {
  return async () => {
    const { data } = await cliente.auth.getSession();
    return data.session?.user.id ?? CONTA_LOCAL;
  };
}
